<script setup lang="ts">
defineProps<{
	modelValue: boolean;
}>();

const emit = defineEmits<{
	"update:modelValue": [value: boolean];
	confirm: [];
}>();

const close = () => {
	emit("update:modelValue", false);
};

const confirm = () => {
	emit("confirm");
	close();
};
</script>

<template>
	<v-dialog :model-value="modelValue" max-width="480" @update:model-value="emit('update:modelValue', $event)">
		<v-card class="pa-2" rounded="xl" elevation="8">
			<v-card-title>Download Information</v-card-title>
			<v-card-text>
				<p>
					If you plan to download, edit and then upload this file,
					<strong>DO NOT</strong> add, change or delete columns or column headers.
				</p>
			</v-card-text>
			<v-card-actions class="d-flex justify-end ga-2">
				<v-btn color="primary" variant="flat" rounded="xl" elevation="0" @click="confirm">OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
